import { BaseApi } from '@/main/baseApi';

import { formatDateTime } from '@/main/utils/dateFormatter';

import { DMS_MODULE, API_NAME, NAME, EXPORT_FILE_NAME } from './constants';


class SestavyApi extends BaseApi {
	constructor() {
		super(DMS_MODULE, API_NAME);
	}

	async GetFullNonReceivedPartReport(filter :any, languageId:any) {
		return this.downloadXlsxReport(
			`/${DMS_MODULE}/${NAME}/GetFullNonReceivedPartReport
			?WorkshopIds=${filter.WorkshopIds}
			&PODateFrom=${formatDateTime(filter.PODateFrom)}
			&PODateTo=${formatDateTime(filter.PODateTo)}
			&LanguageId=${languageId}`,
			EXPORT_FILE_NAME,
		);
	}
}


export const apiProvider = new SestavyApi();
